import { render, staticRenderFns } from "./JournalEntryExpansionPanels.vue?vue&type=template&id=08a5917d&"
import script from "./JournalEntryExpansionPanels.vue?vue&type=script&lang=js&"
export * from "./JournalEntryExpansionPanels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports